// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"1d114ee4","142":"6485e12c","208":"19ff7f6f","325":"4d90e197","358":"064b9a15","384":"1bf0b168","648":"6c2b1753","736":"e622ea30","824":"b4649e02","985":"762a112e"}[chunkId] + ".chunk.js";
};